import { useTranslation } from "react-i18next";

import type { FacilityMarkerData } from "@map/mapiq-map/markers/NodeMarkerData";
import { type FacilityResource, getFloorHasMap, useAppSelector } from "@lib/store";

import { LocationBasedServices } from "../../../../organisms/LocationBasedServices";
import { useHaNLayoutMode } from "../../state/layout/useHaNLayoutMode";
import { ControlsSection } from "../controls/ControlsSection";
import { HaNDetailsPage } from "../HaNDetailsPage";
import { HaNMapPreview } from "../HaNMapPreview";
import { FacilitySummary } from "./components/FacilitySummary";
import { FacilityType } from "./components/FacilityType";

type FacilityInfoPageProps = {
  facility: FacilityResource;
};

export const FacilityInfoPage = ({ facility }: FacilityInfoPageProps) => {
  const { t } = useTranslation();
  const layoutMode = useHaNLayoutMode();
  const floorHasMap = useAppSelector(getFloorHasMap(facility.floorId));

  const marker: FacilityMarkerData = {
    type: "facility",
    nodeId: facility.id,
    subType: facility.data.facilityType.id as FacilityMarkerData["subType"],
  };

  return (
    <HaNDetailsPage title={t("translation:Facility")}>
      <section className="flex flex-col gap-8 px-5 py-6">
        <FacilitySummary facility={facility} />

        <FacilityType facilityType={facility.data.facilityType} />

        <ControlsSection nodeId={facility.id} />

        {floorHasMap && layoutMode === "mobile" && (
          <HaNMapPreview
            buildingId={facility.buildingId}
            floorId={facility.floorId}
            nodeId={facility.id}
            markerData={[marker]}
          />
        )}

        <LocationBasedServices
          buildingId={facility.buildingId}
          locationType="Facility"
          locationName={facility.name}
        />
      </section>
    </HaNDetailsPage>
  );
};
